import type { NearbyOrganization } from "./types/nearby-organization";

function getNearbyOrganizationName(organization: NearbyOrganization): string {
  const nameAttribute = organization.attributes.find(
    (attribute) => attribute.typeName === "Name",
  );

  return nameAttribute?.value || `Office ${organization.number}`;
}

export { getNearbyOrganizationName };
